export const getTransactionDetailURL = (encryptedTransactionId: string) => {
  return `/myaccount/activities/details/${encryptedTransactionId}`
}
